import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { getAmountRetirementNeedToSave, getAmountMonthlyNeedToSaveForRetirement } from '@app/features/my-financial/my-financial';
import { Subscriber } from 'rxjs/Subscriber';

@Component({
  selector: 'app-my-retirement-plan',
  templateUrl: './my-retirement-plan.component.html',
  styleUrls: ['./my-retirement-plan.component.css']
})
export class MyRetirementPlanComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Output() closeModal = new EventEmitter();

  amountRetirementNeedToSave: any;
  amountMonthlyNeedToSaveForRetirement: any;
  formChangedSubcriber: Subscriber<any>;

  ngOnInit() {
    this.amountRetirementNeedToSave = getAmountRetirementNeedToSave(
      this.data.form.value.investmentRates,
      this.data.form.value.inflationRates,
      this.data.form.value.receiveEveryMonth,
      this.data.form.value.timeReceivedIncome
    );
    this.amountMonthlyNeedToSaveForRetirement = getAmountMonthlyNeedToSaveForRetirement(
      this.data.form.value.yearRetirement,
      this.data.form.value.timeReceivedIncome,
      this.data.form.value.receiveEveryMonth,
      this.data.form.value.investmentRates,
      this.data.form.value.inflationRates,
      this.data.form.value.startSavingIn,
      this.data.userAge
    );

    this.formChangedSubcriber = this.data.form.valueChanges.subscribe(formValue => {
      this.amountRetirementNeedToSave = getAmountRetirementNeedToSave(
        formValue.investmentRates,
        formValue.inflationRates,
        formValue.receiveEveryMonth,
        formValue.timeReceivedIncome
      );
      this.amountMonthlyNeedToSaveForRetirement = getAmountMonthlyNeedToSaveForRetirement(
        formValue.yearRetirement,
        formValue.timeReceivedIncome,
        formValue.receiveEveryMonth,
        formValue.investmentRates,
        formValue.inflationRates,
        formValue.startSavingIn,
        this.data.userAge
      );
    });
  }

  ngOnDestroy() {
    this.formChangedSubcriber.unsubscribe();
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/my-financial/my-retirement-plan/my-retirement-plan.component.ts